"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseType = void 0;
var CaseType;
(function (CaseType) {
    CaseType[CaseType["Design"] = 0] = "Design";
    CaseType[CaseType["Rating"] = 1] = "Rating";
    CaseType[CaseType["Bin"] = 2] = "Bin";
    CaseType[CaseType["Erp"] = 3] = "Erp";
    CaseType[CaseType["Eurovent"] = 4] = "Eurovent";
})(CaseType || (exports.CaseType = CaseType = {}));
//# sourceMappingURL=case-type.js.map